var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"space-between"}},[_c('v-col',{staticClass:"subtitle-2",attrs:{"cols":"3","align-self":"center"}},[_vm._v(" Date Paid ")]),_c('v-col',{staticClass:"d-flex justify-end",attrs:{"cols":"5"}},[_c('f-date',{attrs:{"value":_vm.value,"datewallEnd":_vm.endDate},on:{"input":(v) => _vm.$emit('input', v)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }